import { IntegrationSystem } from '@/shared/types';

import { client } from '../core/client';
import { ERZPermit, ErzSearchQueryParams, ResponseExtract, DataResponse, ResponseArtifact } from '../types';

export const permits = {
  getAll: (
    queryParams: {
      permitType?: string;
      numb?: string;
    } = {},
  ): Promise<DataResponse<ERZPermit[]>> => {
    return client.get(`/permits?${new URLSearchParams(queryParams).toString()}`);
  },
  downloadExtract: (extractId?: string): Promise<ResponseArtifact> => {
    const headers = new Headers();
    headers.set('Accept', 'application/pdf');
    headers.set('Content-Type', 'application/octet-stream');

    return client.get(`/permits/extraction/${extractId ?? 'all'}`, { headers });
  },
  searchExtract: (
    queryParams: ErzSearchQueryParams,
    headers?: Headers,
  ): Promise<ResponseExtract<IntegrationSystem.ERZ>> => {
    return client.get(`/weapons/extraction?${new URLSearchParams(queryParams).toString()}`, { headers });
  },
};
